import { Controller } from "@hotwired/stimulus"
import { DonutChart, StackedBarChart, LineChart } from "@carbon/charts"

const SENTIMENT_COLORS = { Positive: "#22A06B", Neutral: "#E8A23D", Negative: "#E0564B" }

export default class extends Controller {
  static values = {
    donut: Object,
    stacked: Array,
    activity: Array
  }
  static targets = ["donut", "stacked", "activity"]

  #charts = {}

  connect() {
    this.#buildDonut()
    this.#buildStacked()
    this.#buildActivity()
  }

  disconnect() {
    Object.values(this.#charts).forEach(c => c?.destroy())
    this.#charts = {}
  }

  #buildDonut() {
    if (!this.hasDonutTarget) return
    const d = this.donutValue
    this.#charts.donut = new DonutChart(this.donutTarget, {
      data: [
        { group: "Positive", value: d.positive || 0 },
        { group: "Neutral",  value: d.neutral  || 0 },
        { group: "Negative", value: d.negative  || 0 }
      ],
      options: {
        height: "176px",
        donut: {
          alignment: "center",
          center: { numberFormatter: () => "" }
        },
        pie: { labels: { enabled: false } },
        color: { scale: SENTIMENT_COLORS },
        legend: { enabled: false },
        toolbar: { enabled: false }
      }
    })
  }

  #buildStacked() {
    if (!this.hasStackedTarget) return
    const rows = this.stackedValue.flatMap(d => [
      { group: "Positive", key: d.date, value: d.positive || 0 },
      { group: "Neutral",  key: d.date, value: d.neutral  || 0 },
      { group: "Negative", key: d.date, value: d.negative  || 0 }
    ])
    this.#charts.stacked = new StackedBarChart(this.stackedTarget, {
      data: rows,
      options: {
        height: "176px",
        axes: {
          left:   { mapsTo: "value", title: "" },
          bottom: { mapsTo: "key", scaleType: "labels", title: "" }
        },
        color: { scale: SENTIMENT_COLORS },
        legend: { position: "bottom", alignment: "center" },
        toolbar: { enabled: false },
        grid: { x: { enabled: false } }
      }
    })
  }

  #buildActivity() {
    if (!this.hasActivityTarget) return
    const rows = this.activityValue.map(d => ({ group: "Mentions", key: d.date, value: d.value }))
    this.#charts.activity = new LineChart(this.activityTarget, {
      data: rows,
      options: {
        height: "176px",
        axes: {
          left:   { mapsTo: "value", title: "" },
          bottom: { mapsTo: "key", scaleType: "labels", title: "" }
        },
        color: { scale: { Mentions: "#1F6FEB" } },
        curve: "curveMonotoneX",
        points: { enabled: false },
        legend: { enabled: false },
        toolbar: { enabled: false },
        grid: { x: { enabled: false } }
      }
    })
  }
}
